import { Decimal } from "classes/DecimalClasses";

import { totalWeight, weightUnit } from "services/utility/afterTouchLine";

export const ZERO_TOTALS = {
  quantity: Decimal.ZERO,
  weight: Decimal.ZERO,
  volume: Decimal.ZERO,
};

export function updateTotals(lines, setTotals) {
  if (!lines || lines.length === 0) {
    setTotals(ZERO_TOTALS);
    return;
  }

  const quantity = lines.reduce(
    (total, line) => total.plus(line.quantity || Decimal.ZERO),
    Decimal.ZERO
  );

  const weight = totalWeight(lines);
  const weightunit = weightUnit(lines);

  // if we ever support more than cbm for volume, this will have to be
  // changed to mirror the weight calculation
  const volume = lines.reduce((total, line) => {
    return total.plus(line.volume);
  }, Decimal.ZERO);

  setTotals({ quantity, weight, weightunit, volume, volumeunit: "cbm" });
}
